import React from 'react'
import './MainPage.scss'

import Island from '../../components/Island'
import Background from '../../components/Background'

export default function MainPage() {
  return (
    <div className="main-page">
      
      <Background />

      <Island />

    </div>
  )
}
